import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from '../../../../localization/useTranslation';
import Tl from '../../../../localization/LocalizationKeys';
import _ from 'lodash';
import ModelType from '../../../Model/ModelType';
import { COMPLEX_SCHEMAS } from '../../../../utils/dtdl';
import ContentTable from '../utils/ContentTable';

const columns = [
  {
    label: Tl.model.id,
    path: 'id',
    searchItem: true,
    isSortable: true
  },
  {
    label: Tl.model.type,
    path: 'type',
    searchItem: true,
    isSortable: true
  },
  {
    label: Tl.model.displayName,
    path: 'displayName',
    searchItem: true,
    isSortable: true
  },
  {
    label: Tl.model.description,
    path: 'description',
    searchItem: true
  },
  {
    label: Tl.model.comment,
    path: 'comment',
    searchItem: true
  }
];


export const SchemaTab = ({ schemas, onSchemasUpdate, modelDraft }) => {
  const T = useTranslation();
  const [schemaModel, setSchemaModel] = useState([]);
  const [_schemas, setSchemas] = useState(schemas);

  useEffect(() => {
    setSchemas(schemas);
  }, [schemas]);

  const updatedContent = useCallback(() => {
    const model = [
      {
        type: ModelType.TEXT,
        label: T.model.id,
        path: 'id',
        isRequired: true,
        hasError: _.isEmpty
      },
      {
        type: ModelType.OPTIONSV2,
        label: T.model.type,
        path: 'type',
        isRequired: true,
        hasError: _.isEmpty,
        options: _.map(COMPLEX_SCHEMAS, (value) => ({ value, text: value }))
      },
      {
        type: ModelType.TEXT,
        label: T.model.displayName,
        path: 'displayName',
        isRequired: true,
        hasError: _.isEmpty
      },
      {
        type: ModelType.TEXT,
        label: T.model.description,
        path: 'description',
        isRequired: false
      },
      {
        type: ModelType.TEXT,
        label: T.model.comment,
        path: 'comment'
      }
    ];
    setSchemaModel(model);
  }, [T.model.comment, T.model.description, T.model.displayName, T.model.id, T.model.type]);

  useEffect(() => {
    updatedContent();
  }, [updatedContent]);

  const onSave = useCallback((content) => {
    onSchemasUpdate(content);
  }, [onSchemasUpdate]);
  return (
    <>
      <ContentTable
        title={T.model.tab.schema}
        columns={columns}
        data={_schemas}
        dialogModel={schemaModel}
        updatedContent={updatedContent}
        onSave={onSave}
        modelDraft={modelDraft}
      />
    </>
  );
};
